<script>
    import {onMount} from "svelte";
    import gsap from "gsap";
    import {labels, mainTimeline} from "../../timelines/main-timeline";

    const inTimeLine = gsap.timeline();
    const outTimeline = gsap.timeline();
    const {leadersStart, leadersEnd} = labels;

    const nums = Array.from(Array(9)).map((_, i) => i + 1);

    onMount(() => {
        nums.forEach(n => {
            inTimeLine.from('.num' + n, {
                opacity: 0,
                duration: 0.1,
            });

            if (n < 9) {
                inTimeLine.to('.num' + n, {
                    opacity: 0,
                    duration: 0.1,
                }, '<+=0.1');
            }
        })

        outTimeline.to('.num9', {
            scale: 0.025,
            duration: 0.5,
            transformOrigin: 'center',
        }).to('.num9', {
            opacity: 0,
            duration: 0.15,
        })

        mainTimeline.add(inTimeLine, leadersStart);
        mainTimeline.add(outTimeline, leadersEnd);
    });
</script>

{#each nums as n}
    <text class={'number num' + n} x="800" y="900">{n}</text>
{/each}

<style>
    .number {
        font-size: 660px;
        font-weight: 600;
    }
</style>